export const DEFAULT_FONT_SIZE_SCALE = 100;
export const MEDIUM_FONT_SIZE_SCALE = 150;
export const MAXIMUM_FONT_SIZE_SCALE = 200;

export const DEFAULT_ACCESSIBILITY_SCOPE = 'mclass-default';

export const ZOOM_CONFIG = 'config.zoom';
export const IS_MAZE_UNTIMED = 'config.isMazeUntimed';
export const IS_CAPTIONS_ENABLED = 'config.isCaptionsEnabled';
export const IS_ANIMATION_VISUAL_REDUCED = 'config.isAnimationVisualReduced';
export const CAPTIONS = 'captions';
export const ALYX_ANIMATION = 'alyxAnimation';
export const TEXT_SIZE = 'textSize';
